/**
 * 단어별로 이미 받은 예문을 기억한다. '다른 예문 보기' 요청 때 서버에 넘겨
 * 같은 예문이 다시 나오지 않게 한다. 단어마다 최근 limit 개만 남긴다.
 */
export default class SentenceHistory {
  private sentencesByTerm = new Map<string, string[]>();
  private readonly limit: number;

  constructor(limit: number = 10) {
    this.limit = limit;
  }

  append(term: string, sentence: string) {
    if (sentence.length === 0) return;

    const sentences = [...(this.sentencesByTerm.get(term) ?? []), sentence];
    this.sentencesByTerm.set(term, sentences.slice(-this.limit));
  }

  sentences(term: string): string[] {
    return this.sentencesByTerm.get(term) ?? [];
  }
}
